import React from 'react';

import { Button, DropdownMenu, Text } from '@betterment/samba-react';

import { useSessionState } from '../hooks/useSessionState';

export const AgentsDropdown: React.FC = () => {
  const { setAgentConfig } = useSessionState();
  return (
    <DropdownMenu>
      <DropdownMenu.Trigger asChild={true}>
        <Button variant="ghostPrimary">Select agent</Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content>
        <DropdownMenu.Item onSelect={() => setAgentConfig('accounts_advisor')}>
          <Text variant="text100">Accounts advisor</Text>
        </DropdownMenu.Item>
        <DropdownMenu.Item onSelect={() => setAgentConfig('platform_testing')}>
          <Text variant="text100">Platform testing</Text>
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};
